<script setup>
import { onMounted, onServerPrefetch } from "vue";
import { useProductsStore } from "./stores/products.store";
import MessageModal from "./components/MessageModal.vue";
import { injectJsonLdOrganization } from "@/helpers/seo.js";

async function initializeApp() {
    try {
        const productsStore = useProductsStore();
        if (productsStore.categories?.length > 0 || productsStore.fastDeliveryData?.length > 0) {
            return;
        }
        if (!import.meta.env.SSR) {
            productsStore.turnOnLoading();
        }
        await productsStore.fetchVersionAndUpdateProducts();
    } catch (error) {
        console.error("Failed to initialize app:", error);
        if (!import.meta.env.SSR) {
            useProductsStore().turnOffLoading();
        }
    }
}

onServerPrefetch(async () => {
    await initializeApp();
});

// Run after mount so SSR DOM + Pinia hydrate finish first; avoids "Hydration mismatch"
// from IDB/catalog updates racing Vue’s hydration of #app.
onMounted(() => {
    injectJsonLdOrganization();
    if (!import.meta.env.SSR) {
        void initializeApp();
    }
});
</script>

<template>
    <RouterView />
    <MessageModal />
</template>
